// extracted by mini-css-extract-plugin
module.exports = {"activitiesList":"issueDetails_activitiesList_24hRAm2"};